/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TimeZoneInfoDto
 */
export interface TimeZoneInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneInfoDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TimeZoneInfoDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof TimeZoneInfoDto
     */
    $type?: TimeZoneInfoDtoTypeEnum;
}


/**
 * @export
 */
export const TimeZoneInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoTimeZoneInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.TimeZoneInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TimeZoneInfoDtoTypeEnum = typeof TimeZoneInfoDtoTypeEnum[keyof typeof TimeZoneInfoDtoTypeEnum];



/**
 * Check if a given object implements the TimeZoneInfoDto interface.
 */
export function instanceOfTimeZoneInfoDto(value?: unknown): value is TimeZoneInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TimeZoneInfoDtoTypeEnum)[0];
}

export function TimeZoneInfoDtoFromJSON(json: any): TimeZoneInfoDto {
    return TimeZoneInfoDtoFromJSONTyped(json, false);
}

export function TimeZoneInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeZoneInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TimeZoneInfoDtoToJSON(value?: TimeZoneInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'displayName': value['displayName'],
        '$type': value['$type'],
    });
}

